import { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import styles from './Styles/index.module.scss'

interface Props {
    value: number
    options: number[]
    onChange: (value: number) => void
    label?: string
}

export const CustomPaginationDropdown = ({
    value,
    options,
    onChange,
    label,
}: Props) => {
    const [isOpen, setIsOpen] = useState(false)
    const [openUpwards, setOpenUpwards] = useState(false)
    const dropdownRef = useRef(null)
    const buttonRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (e: any) => {
            if (
                dropdownRef.current &&
                // @ts-ignore
                !dropdownRef.current.contains(e.target)
            ) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () =>
            document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    useEffect(() => {
        if (isOpen && buttonRef.current) {
            // @ts-ignore
            const buttonRect = buttonRef.current.getBoundingClientRect()
            const dropdownHeight = 200
            const spaceBelow = window.innerHeight - buttonRect.bottom
            const spaceAbove = buttonRect.top

            setOpenUpwards(
                spaceBelow < dropdownHeight && spaceAbove > spaceBelow
            )
        }
    }, [isOpen])

    const handleSelect = (optionValue: number) => {
        onChange(optionValue)
        setIsOpen(false)
    }

    return (
        <div className={styles.dropdown}>
            {label && <label className={styles.dropdownLabel}>{label}</label>}
            <div
                ref={dropdownRef}
                style={{ position: 'relative' }}
            >
                <button
                    className={styles.dropdownBtn}
                    ref={buttonRef}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <span>{value}</span>
                    <span className={styles.dropdownChevron}>
                        <FontAwesomeIcon
                            style={{
                                transition: 'transform 0.2s',
                                transform: isOpen
                                    ? 'rotate(180deg)'
                                    : 'rotate(0deg)',
                            }}
                            icon={faChevronDown}
                        />
                    </span>
                </button>

                {isOpen && (
                    <div
                        style={{
                            position: 'absolute',
                            ...(openUpwards
                                ? { bottom: 'calc(100% + 4px)' }
                                : { top: 'calc(100% + 4px)' }),
                            left: 0,
                            right: 0,
                            backgroundColor: 'white',
                            border: '1px solid #ced4da',
                            borderRadius: '0.25rem',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            zIndex: 1000,
                            maxHeight: '200px',
                            overflowY: 'auto',
                        }}
                    >
                        {options.map((option) => (
                            <div
                                key={option}
                                onClick={() => handleSelect(option)}
                                style={{
                                    padding: '0.5rem 0.75rem',
                                    cursor: 'pointer',
                                    fontSize: '0.875rem',
                                    backgroundColor:
                                        option === value ? '#e7f3ff' : 'white',
                                    color:
                                        option === value
                                            ? '#4B6687'
                                            : '#212529',
                                    transition: 'background-color 0.15s',
                                    borderLeft:
                                        option === value
                                            ? '3px solid #4B6687'
                                            : '3px solid transparent',
                                }}
                                onMouseEnter={(e) => {
                                    if (option !== value) {
                                        // @ts-ignore
                                        e.target.style.backgroundColor =
                                            '#f8f9fa'
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (option !== value) {
                                        // @ts-ignore
                                        e.target.style.backgroundColor = 'white'
                                    }
                                }}
                            >
                                {option}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
